import React from 'react';
import { Box } from '@mui/material';

/**
 * Banner as a real <img> so the uploaded bitmap (e.g. 800×280) scales uniformly with the card
 * and matches the crop dialog — avoids background-size cover/contain mismatches.
 */
export default function BannerStrip({ imageUrl, fallbackBg = '#f8f9fa', borderRadius, sx = {} }) {
  if (!imageUrl) return null;
  return (
    <Box
      sx={{
        width: '100%',
        bgcolor: fallbackBg,
        lineHeight: 0,
        overflow: 'hidden',
        ...(borderRadius != null ? { borderRadius } : {}),
        ...sx,
      }}
    >
      <Box
        component="img"
        src={imageUrl}
        alt=""
        decoding="async"
        sx={{
          width: '100%',
          height: 'auto',
          display: 'block',
        }}
      />
    </Box>
  );
}
